import { GladlyBox } from '@castlery/shared-components';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { MarketCheck } from '../market-check';

export async function WebMainLayout({ children }: { children?: React.ReactNode }) {
  return (
    <>
      <GladlyBox />
      <Header />
      {children}
      <Footer />
      <MarketCheck />
    </>
  );
}
